import React from 'react';
import cn from 'classnames';

import Button from 'components/Button';
import Modal from '../';
import classes from './modalConfirm.module.scss';
import { IModalConfirm } from './types';

const ModalConfirm: React.FC<IModalConfirm> = ({
	className,
	isOpen,
	onConfirm,
	onClose,
	title,
	text,
	confirmButtonText = 'Да',
	cancelButtonText = 'Нет',
	confirmButtonClassName = '',
	cancelButtonClassName = 'Нет',
	isLoading,
}) => {
	return (
		<Modal
			className={cn(classes.modalConfirm, className)}
			isOpen={isOpen}
			onClose={onClose}
		>
			{title && <div className={classes.title}>{title}</div>}
			{text && <div className={classes.text}>{text}</div>}
			<div className={classes.buttons}>
				<Button
					className={cn(
						classes.buttonConfirm,
						confirmButtonClassName
					)}
					text={confirmButtonText}
					onClick={onConfirm}
					isLoading={isLoading}
				/>
				<Button
					className={cn(classes.buttonCancel, cancelButtonClassName)}
					text={cancelButtonText}
					styleType="secondary"
					onClick={onClose}
				/>
			</div>
		</Modal>
	);
};

export default ModalConfirm;
